import { enqueueGAEvent as enqueueGAEventUtil } from '../../../features/analytics/eventQueue';

const enqueueGAEvent = (
  eventCategory,
  eventAction,
  eventLabel,
  fieldsObject,
) => {
  return (target, name, descriptor) => {
    const original = descriptor.value;

    const wrapperFunction = (...args) => {
      const actionObjectLiteral = original.apply(target, args) || {};
      enqueueGAEventUtil(eventCategory, eventAction, eventLabel, fieldsObject);
      return actionObjectLiteral;
    };

    // This type is assigned in the actionCreator decorator and were essentially passing it through this decorator
    wrapperFunction.TYPE = descriptor.value.TYPE;
    wrapperFunction.toString = () => wrapperFunction.TYPE;

    descriptor.value = wrapperFunction;
    return descriptor;
  };
};

export default enqueueGAEvent;
